<div class="social-wrap">
  <button class="social-btn facebook" (click)="share('facebook')" matTooltip="שתף בפייסבוק">
    <i class="fa fa-facebook-f"></i>
  </button>
  <button class="social-btn twitter" (click)="share('twitter')" matTooltip="שתף בטוויטר">
    <i class="fa fa-twitter"></i>
  </button>
  <button class="social-btn linkedin" (click)="share('linkedin')" matTooltip="שתף בלינקדאין">
    <i class="fa fa-linkedin"></i>
  </button>
  <button class="social-btn pinterest" (click)="share('pinterest')" matTooltip="שתף בפינטרסט">
    <i class="fa fa-pinterest-p"></i>
  </button>
</div>
